import React, { FC } from 'react';

/* types */
import { StyledBoxProps } from "../";
import { BoxProps as MuiBoxProps } from '@mui/material';

/* styled */
import { StyledBox , Spinner } from './styled';

export const Box: FC<MuiBoxProps & StyledBoxProps> = (props) => {
  return <StyledBox {...props} >
    {props.children}
    {props?.loading && (
      <Spinner size={props.loadingSize ? props.loadingSize : 24}
               thickness={4}
               color={'grayscaleSecondary'}
      />
    )}
  </StyledBox>
};
